import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: "100%",
    backgroundColor: "#184171",
    alignItems: "center",
  },

  logoText: {
    textTransform: "uppercase",
    fontWeight: "bold",
    marginTop: 10,
    fontSize: 32,
    color: "#fff",
  },
  loginContainer: {
    position: "absolute",
    bottom: 20,
    width: "100%",
    height: "40%",
    justifyContent: "center",
    alignItems: "center",
  },

  button: {
    padding: 10,
    minWidth: 350,
    minHeight: 60,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    marginTop: "3%",
  },
  btnRegistrar: {
    backgroundColor: "",
    width: 350,
    height: 60,
    borderRadius: 4,
    justifyContent: "center",
    alignItems: "center",
  },
  loginButton: {
    backgroundColor: "#077A97",
    borderColor: "#077A97",
    borderWidth: 0,
  },
  text: {
    textTransform: "uppercase",
    fontWeight: "700",
    letterSpacing: 1,
  },
});

export default styles;
